import axios from "axios";
import { useMutation } from "react-query";
import { END_POINT } from "config/environment";
import {
  ApiDataResponse,
  AuthorizationRole,
  CreateRoleRequest,
} from "../types";

export const addRole = async ({
  token,
  ...payload
}: CreateRoleRequest): Promise<ApiDataResponse<AuthorizationRole>> => {
  const url = `${END_POINT.BASE_URL}/v1/administrator/authorization/roles`;
  const config = {
    headers: {
      Accept: "application/json",
      Authorization: `Bearer ${token}`,
    },
  };

  const response = await axios.post<ApiDataResponse<AuthorizationRole>>(
    url,
    payload,
    config
  );
  return response.data;
};

export const useAddRole = () => {
  return useMutation(addRole);
};